export const OFFER = 'Offer';
export const OFFERS = 'Offers';
export const PERMONTH = '/mo';
export const DOLLAR = '$';
